import { CheckOut, MTNValidation, CheckLQ } from './../constants/actionType'
import $ from 'jquery';

const initialState = {
    // ph2: '',
    // ph3: ''
    contactInfo: {
        fName: "",
        lName: "",
        fNameErr: "",
        lNameErr: "",
        isValidfName: false,
        isValidlName: false,
        errorMsg: "",
        bNameEnc: "",
        eMailId: "",
        eMailErr: "",
        phoneNoErr: "",
        isValidMail: false,
        isValidTN: false,
        emailValidationResp:"",
        emailRegexValid:true,
        clickHereFlag:false,

        phoneNo: {
            ph1: '',
            formattedph1: ''
        },
        tnType: "Mobile",
        isSMSOptIn: false,
        digitalBilling: "N",

        isFSCallBackSchduled: false,
        isFSCallBackInProgress: false,
        fiosSupportMDN: {
            fsph1: '',
            formattedfsph1: ''
        },
        fiosSupportDate: $.datepicker.formatDate('mm/dd/yy', new Date()),
        fiosSupportAvailableTimeSlot: [
            {
                startTime : "",
                endTime : "",
                slotOrder : ""
            },
        ],
        fiosSupportSelectedTimeSlot: [
            {
                startTime : "",
                endTime : "",
                slotOrder : ""
            },
        ]
    },
    billingAdrInfo: {
        isSameAsServiceAddress: "Y",
        streetAdress: "",
        unitType: "",
        unitVal: "",
        city: "",
        zipCode: "",
        state: "",
        isValidBillingAddress: true,
        noOfAttempts: 0,
        billingAddress: "",
        billingAddressEnc: "",
        srvAdr: "",
        dpvFlag: "Y"
    },
    isContactInfoValidated: false,
    isBillingInfoValidated: false,
    isSentOTP:false,
    otpData:"",
    isOTPValidated:false,
    noOfOTPAttemps : 0,
    contactValidationStatus : ''
};

    function personalInfo(state = initialState, action) {
    switch (action.type) {

        case CheckOut.onNameValidation:
            let validateddetails = Object.assign({}, state.contactInfo, {
                isValidfName: action.value.isValidFirstName,
                isValidlName: action.value.isValidLastName,
                fNameErr: (!action.value.isValidFirstName) ? "Please check the name you entered and enter the legal name" : state.contactInfo.fNameErr,
                lNameErr: (!action.value.isValidLastName) ? "Please check the name you entered and enter the legal name" : state.contactInfo.lNameErr
            })
            return Object.assign({}, state, {
                contactInfo: validateddetails
            })


        case CheckOut.onContactValidation:
            let validateddata = Object.assign({}, state.contactInfo, {
                isValidMail: (action.value.emailIdValidationResult !== undefined && action.value.emailIdValidationResult.validationResult === 'INVALID') ? false : true,
                eMailErr: (action.value.emailIdValidationResult !== undefined && action.value.emailIdValidationResult.validationResult === 'INVALID') ? "Please enter a valid email address" : state.contactInfo.eMailErr,
                isValidTN: (action.value.mobileNumberValidationResult !== undefined && action.value.mobileNumberValidationResult.validationResult === 'INVALID') ? false : true,
                phoneNoErr: (action.value.mobileNumberValidationResult !== undefined && action.value.mobileNumberValidationResult.validationResult === 'INVALID') ? "Please enter Valid Contact #" : state.contactInfo.phoneNoErr,
            })

            let isvalidateddata = false;
            if (state.contactInfo.isValidfName && state.contactInfo.isValidlName
                && validateddata.isValidMail && validateddata.isValidTN
                && state.contactInfo.errorMsg === "") {
                isvalidateddata = true;
            }
            else if (action.value.isvalidateddata !== undefined) {
                isvalidateddata = action.value.isvalidateddata
            }

            return Object.assign({}, state, {
                contactInfo: validateddata,
                isContactInfoValidated: isvalidateddata
            })

        case CheckOut.updateNameInfo:
            let details = Object.assign({}, state.contactInfo, {
                fName: (action.value.fName !== undefined && action.value.fName !== state.contactInfo.fName) ? action.value.fName : state.contactInfo.fName,
                lName: (action.value.lName !== undefined && action.value.lName !== state.contactInfo.lName) ? action.value.lName : state.contactInfo.lName,
                fNameErr: (action.value.fNameErr !== undefined && action.value.fNameErr !== state.contactInfo.fNameErr) ? action.value.fNameErr : state.contactInfo.fNameErr,
                lNameErr: (action.value.lNameErr !== undefined && action.value.lNameErr !== state.contactInfo.lNameErr) ? action.value.lNameErr : state.contactInfo.lNameErr,
                errorMsg: (action.value.errorMsg !== undefined && action.value.errorMsg !== state.contactInfo.errorMsg) ? action.value.errorMsg : state.contactInfo.errorMsg,
                isValidfName: (action.value.isValidfName !== undefined && action.value.isValidfName !== state.contactInfo.isValidfName) ? action.value.isValidfName : state.contactInfo.isValidfName,
                isValidlName: (action.value.isValidlName !== undefined && action.value.isValidlName !== state.contactInfo.isValidlName) ? action.value.isValidlName : state.contactInfo.isValidlName,
                bNameEnc: window.ProtectString !== undefined && window.ProtectString && window.ProtectString(state.contactInfo.fName + " " + state.contactInfo.lName)
            })
            return Object.assign({}, state, {
                contactInfo: details
            })

        case CheckOut.updateContactInfo:
            let data = Object.assign({}, state.contactInfo, {
                eMailId: (action.value.eMailId !== undefined && action.value.eMailId !== state.contactInfo.eMailId) ? action.value.eMailId : state.contactInfo.eMailId,
                eMailErr: (action.value.eMailErr !== undefined && action.value.eMailErr !== state.contactInfo.eMailErr) ? action.value.eMailErr : state.contactInfo.eMailErr,
                isValidMail: (action.value.isValidMail !== undefined && action.value.isValidMail !== state.contactInfo.isValidMail) ? action.value.isValidMail : state.contactInfo.isValidMail,
                isValidTN: (action.value.isValidTN !== undefined && action.value.isValidTN !== state.contactInfo.isValidTN) ? action.value.isValidTN : state.contactInfo.isValidTN,
                phoneNoErr: (action.value.phoneNoErr !== undefined && action.value.phoneNoErr !== state.contactInfo.phoneNoErr) ? action.value.phoneNoErr : state.contactInfo.phoneNoErr,
                tnType: (action.value.tnType !== undefined && action.value.tnType !== state.contactInfo.tnType) ? action.value.tnType : state.contactInfo.tnType,
                isSMSOptIn: (action.value.isSMSOptIn !== undefined && action.value.isSMSOptIn !== state.contactInfo.isSMSOptIn) ? action.value.isSMSOptIn : state.contactInfo.isSMSOptIn

            })
            return Object.assign({}, state, {
                contactInfo: data,
                isContactInfoValidated: (action.value.isContactInfoValidated !== undefined) ? action.value.isContactInfoValidated : state.isContactInfoValidated
            })

        case 'UPDATE_PH1':
            let ph1 = Object.assign({}, state.contactInfo.phoneNo, {
                ph1: action.value
            })
            let ph1data = Object.assign({}, state.contactInfo, {
                phoneNo: ph1
            })
            return Object.assign({}, state, {
                contactInfo: ph1data
            })

        case CheckOut.updateFormattedphone:
            let formattedph1 = Object.assign({}, state.contactInfo.phoneNo, {
                formattedph1: action.value
            })
            let formattedph1data = Object.assign({}, state.contactInfo, {
                phoneNo: formattedph1
            })
            return Object.assign({}, state, {
                contactInfo: formattedph1data
            })
       /* case 'UPDATE_PH2':
            let ph2 = Object.assign({}, state.contactInfo.phoneNo, {
                ph2: action.value
            })
            let ph2data = Object.assign({}, state.contactInfo, {
                phoneNo: ph2
            })
            return Object.assign({}, state, {
                contactInfo: ph2data
            })
        case 'UPDATE_PH3':
            let ph3 = Object.assign({}, state.contactInfo.phoneNo, {
                ph3: action.value
            })
            let ph3data = Object.assign({}, state.contactInfo, {
                phoneNo: ph3
            })
            return Object.assign({}, state, {
                contactInfo: ph3data
            })
*/
        case CheckOut.updateBillingAddrInfo:
            let billingAdrData = Object.assign({}, state.billingAdrInfo, {
                streetAdress: (action.value.streetAdress !== undefined && action.value.streetAdress !== state.billingAdrInfo.streetAdress) ? action.value.streetAdress : state.billingAdrInfo.streetAdress,
                unitType: (action.value.unitType !== undefined && action.value.unitType !== state.billingAdrInfo.unitType) ? action.value.unitType : state.billingAdrInfo.unitType,
                unitVal: (action.value.unitVal !== undefined && action.value.unitVal !== state.billingAdrInfo.unitVal) ? action.value.unitVal : state.billingAdrInfo.unitVal,
                city: (action.value.city !== undefined && action.value.city !== state.billingAdrInfo.city) ? action.value.city : state.billingAdrInfo.city,
                state: (action.value.state !== undefined && action.value.state !== state.billingAdrInfo.state) ? action.value.state : state.billingAdrInfo.state,
                zipCode: (action.value.zipCode !== undefined && action.value.zipCode !== state.billingAdrInfo.zipCode) ? action.value.zipCode : state.billingAdrInfo.zipCode,
                isValidBillingAddress: (action.value.isValidBillingAddress !== undefined && action.value.isValidBillingAddress !== state.billingAdrInfo.isValidBillingAddress) ? action.value.isValidBillingAddress : state.billingAdrInfo.isValidBillingAddress,
                isSameAsServiceAddress: (action.value.isSameAsServiceAddress !== undefined && action.value.isSameAsServiceAddress !== state.billingAdrInfo.isSameAsServiceAddress) ? action.value.isSameAsServiceAddress : state.billingAdrInfo.isSameAsServiceAddress,
                noOfAttempts: (action.value.noOfAttempts !== undefined) ? action.value.noOfAttempts : state.billingAdrInfo.noOfAttempts,
                billingAddress: (action.value.billingAddress !== undefined) ? action.value.billingAddress : state.billingAdrInfo.billingAddress,
                billingAddressEnc: window.ProtectString !== undefined && window.ProtectString((action.value.billingAddress !== undefined) ? action.value.billingAddress : state.billingAdrInfo.billingAddress),
                srvAdr: ((action.value.srvcAddress !== undefined) ? action.value.srvcAddress : (state.billingAdrInfo.srvcAddress !== undefined ? state.billingAdrInfo.srvcAddress : ""))
            })
            return Object.assign({}, state, {
                billingAdrInfo: billingAdrData,
                isBillingInfoValidated: (action.value.isBillingInfoValidated !== undefined) ? action.value.isBillingInfoValidated : state.isBillingInfoValidated
            })

        case CheckOut.onBillingAddressValidation:
            let validatedbillinginfo = Object.assign({}, state.billingAdrInfo, {
                isValidBillingAddress: (action.value.billingAddress !== undefined) ? action.value.billingAddress.addressValidated : state.billingAdrInfo.isValidBillingAddress,
                noOfAttempts: state.billingAdrInfo.noOfAttempts + 1,
                isSameAsServiceAddress: (action.value.billingAddress !== undefined && !action.value.billingAddress.addressValidated) ? "N" : state.billingAdrInfo.isSameAsServiceAddress,
                dpvFlag: (action.value.billingAddress !== undefined && action.value.billingAddress.dpvFlag !== null && action.value.billingAddress.dpvFlag !== undefined) ? action.value.billingAddress.dpvFlag : state.billingAdrInfo.dpvFlag
            })
            return Object.assign({}, state, {
                billingAdrInfo: validatedbillinginfo,
                isBillingInfoValidated: validatedbillinginfo.isValidBillingAddress
            })
        case CheckOut.onBillingAddressSystemError:
            let validatedbillinginfoSystemError = Object.assign({}, state.billingAdrInfo, {
                isValidBillingAddress: true,
                noOfAttempts: state.billingAdrInfo.noOfAttempts + 1,
                isSameAsServiceAddress: (action.value.billingAddress !== undefined && !action.value.billingAddress.addressValidated) ? "N" : state.billingAdrInfo.isSameAsServiceAddress,
                dpvFlag: (action.value.billingAddress !== undefined && action.value.billingAddress.dpvFlag !== null && action.value.billingAddress.dpvFlag !== undefined) ? action.value.billingAddress.dpvFlag : state.billingAdrInfo.dpvFlag
            })
            return Object.assign({}, state, {
                billingAdrInfo: validatedbillinginfoSystemError,
                isBillingInfoValidated: validatedbillinginfoSystemError.isValidBillingAddress
            })

        case CheckOut.isOnLoadBillingAddressValidation:
            let onLoadCheck = Object.assign({}, state.billingAdrInfo, {
                noOfAttempts: (action.value !== undefined && action.value) ? state.billingAdrInfo.noOfAttempts -1 : state.billingAdrInfo.noOfAttempts,
            })
            return Object.assign({}, state, {
                billingAdrInfo: onLoadCheck
            })
        case MTNValidation.updateOTPSentStaus:
            return Object.assign({}, state, {
                isSentOTP: action.value
            })

        case MTNValidation.updateOTPInfo:
            return Object.assign({}, state, {
                otpData: action.value
            })

        case MTNValidation.updateVerifyOTP:
            return Object.assign({}, state, {
                isOTPValidated: action.value
            })
        case 'UPDATE_PHONE': 
        /*
        ph2: action.value.ph2,
        ph3: action.value.ph3*/
        let ph = Object.assign({}, state.contactInfo.phoneNo, {
                ph1: action.value.ph1
        })
        let phdata = Object.assign({}, state.contactInfo, {
            phoneNo: ph
        })
        return Object.assign({}, state, {
            contactInfo: phdata
        })

        case MTNValidation.updateOTPAttempts:
            return Object.assign({}, state, {
                noOfOTPAttemps: action.value
        })
        case "EMPTY_PERSONAL_INFO":
        return initialState

        case CheckLQ.mnhCheckoutInfo:
            /* ,
                ph2: (action.value.mtn) ? action.value.mtn.slice(3, 6) : state.contactInfo.phoneNo.ph2,
                ph3: (action.value.mtn) ? action.value.mtn.slice(6, 10) : state.contactInfo.phoneNo.ph3*/ 
            let phone_Number = Object.assign({}, state.contactInfo.phoneNo, {
                ph1: (action.value.mtn) ? action.value.mtn : state.contactInfo.phoneNo.ph1
            })
        let mnhData = Object.assign({}, state.contactInfo, {
            fName: (action.value.firstName) ? action.value.firstName : state.contactInfo.fName,
            lName: (action.value.lastName) ? action.value.lastName : state.contactInfo.lName,
            isValidfName: (action.value.firstName) ? true : state.contactInfo.isValidfName,
            isValidlName: (action.value.lastName) ? true : state.contactInfo.isValidlName,
            eMailId: (action.value.emailId) ? action.value.emailId : state.contactInfo.eMailId,
            isValidMail: (action.value.emailId) ? true : state.contactInfo.isValidMail,
            phoneNo: phone_Number,
            isValidTN: (action.value.mtn) ? true : state.contactInfo.isValidTN,
            isSMSOptIn: (action.value.smsOptIn) ? action.value.smsOptIn == 'Y' ? true : false : state.contactInfo.isSMSOptIn,
            bNameEnc: window.ProtectString !== undefined && window.ProtectString && window.ProtectString(action.value.firstName ? action.value.firstName : state.contactInfo.fName + " " + action.value.lastName ? action.value.lastName : state.contactInfo.lName)
        })
        let mnhBilingAdr = Object.assign({},state.billingAdrInfo,{
            isSameAsServiceAddress:"Y",
            isValidBillingAddress:true
        })
        return Object.assign({}, state, {
            contactInfo: mnhData,
            isContactInfoValidated: mnhData.isValidTN && mnhData.isValidMail,
            isBillingInfoValidated: true,
            billingAdrInfo:mnhBilingAdr

        })
        case "ACP_DETAILS_UPDATE":
            let phone_NumberACP = Object.assign({}, state.contactInfo.phoneNo, {
                ph1: (action.value.mtn) ? action.value.mtn : state.contactInfo.phoneNo.ph1
            })
            let acpData = Object.assign({}, state.contactInfo, {
                fName: (action.value.firstName) ? action.value.firstName : state.contactInfo.fName,
                lName: (action.value.lastName) ? action.value.lastName : state.contactInfo.lName,
                isValidfName: (action.value.firstName) ? true : state.contactInfo.isValidfName,
                isValidlName: (action.value.lastName) ? true : state.contactInfo.isValidlName,
                eMailId: (action.value.emailId) ? action.value.emailId : state.contactInfo.eMailId,
                isValidMail: (action.value.emailId) ? true : state.contactInfo.isValidMail,
                phoneNo: phone_NumberACP,
                isValidTN: (action.value.mtn) ? true : state.contactInfo.isValidTN
            })
            return Object.assign({}, state, {
                contactInfo: acpData    
            })

        case "CUST_DETAILS_UPDATE":
            let phone_NumberCust = Object.assign({}, state.contactInfo.phoneNo, {
                ph1: (action.value.mtn) ? action.value.mtn : state.contactInfo.phoneNo.ph1
            })
            let custData = Object.assign({}, state.contactInfo, {
                fName: (action.value.firstName) ? action.value.firstName : state.contactInfo.fName,
                lName: (action.value.lastName) ? action.value.lastName : state.contactInfo.lName,
                isValidfName: (action.value.firstName) ? true : state.contactInfo.isValidfName,
                isValidlName: (action.value.lastName) ? true : state.contactInfo.isValidlName,
                eMailId: (action.value.comboEmail) ? action.value.comboEmail : state.contactInfo.eMailId,
                isValidMail: (action.value.comboEmail) ? true : state.contactInfo.isValidMail,
                phoneNo: phone_NumberCust,
                isValidTN: (action.value.mtn) ? true : state.contactInfo.isValidTN
            })
            return Object.assign({}, state, {
                contactInfo: custData    
            })

        case "MNHUPDATEBILLINGINFO":
        return Object.assign({}, state, {
            isBillingInfoValidated: true
        })
        
        case 'UPDATE_EMAIL_VALIDATION':
        let emailValObj = Object.assign({}, state.contactInfo, {
            emailValidationResp : action.value
        })
        return Object.assign({}, state, {
            contactInfo: emailValObj
        })
    case 'UPDATE_CLICK_FLAG':
        let clickObj = Object.assign({}, state.contactInfo, {
            clickHereFlag : action.value
        })
        return Object.assign({}, state, {
            contactInfo: clickObj
        })
    case 'UPDATE_EMAIL_REGEX':
        let eRegexObj = Object.assign({}, state.contactInfo, {
            emailRegexValid : action.value
        })
        return Object.assign({}, state, {
            contactInfo: eRegexObj
        })

    case CheckOut.updateFiosSupportMDN:
        let fiosSupportData = Object.assign({}, state.contactInfo, {
            //eMailId: (action.value.eMailId !== undefined && action.value.eMailId !== state.contactInfo.eMailId) ? action.value.eMailId : state.contactInfo.eMailId,
            //eMailErr: (action.value.eMailErr !== undefined && action.value.eMailErr !== state.contactInfo.eMailErr) ? action.value.eMailErr : state.contactInfo.eMailErr,
            //isValidMail: (action.value.isValidMail !== undefined && action.value.isValidMail !== state.contactInfo.isValidMail) ? action.value.isValidMail : state.contactInfo.isValidMail,
            isValidTN: (action.value.isValidTN !== undefined && action.value.isValidTN !== state.contactInfo.fiosSupportMDN.isValidTN) ? action.value.isValidTN : state.contactInfo.fiosSupportMDN.isValidTN,
            phoneNoErr: (action.value.phoneNoErr !== undefined && action.value.phoneNoErr !== state.contactInfo.fiosSupportMDN.phoneNoErr) ? action.value.phoneNoErr : state.contactInfo.fiosSupportMDN.phoneNoErr,
            //tnType: (action.value.tnType !== undefined && action.value.tnType !== state.contactInfo.tnType) ? action.value.tnType : state.contactInfo.tnType,
            //isSMSOptIn: (action.value.isSMSOptIn !== undefined && action.value.isSMSOptIn !== state.contactInfo.isSMSOptIn) ? action.value.isSMSOptIn : state.contactInfo.isSMSOptIn

        })
        return {
            ...state,
            contactInfo : {
                ...state.contactInfo,
                fiosSupportMDN: fiosSupportData
            }
        }
        // return Object.assign({}, state, {
        //     contactInfo: data,
        //     isContactInfoValidated: (action.value.isContactInfoValidated !== undefined) ? action.value.isContactInfoValidated : state.isContactInfoValidated
        // })

        case 'UPDATE_FSPH1':
            let fsph1 = Object.assign({}, state.contactInfo.fiosSupportMDN, {
                fsph1: action.value
            })
            let fsph1data = Object.assign({}, state.contactInfo, {
                fiosSupportMDN: fsph1
            })
            return Object.assign({}, state, {
                contactInfo: fsph1data
            })

        case CheckOut.updateFormattedFSMDNphone:
            let formattedFSph1 = Object.assign({}, state.contactInfo.fiosSupportMDN, {
                formattedfsph1: action.value
            })
            let formattedph1FSdata = Object.assign({}, state.contactInfo, {
                fiosSupportMDN: formattedFSph1
            })
            return Object.assign({}, state, {
                contactInfo: formattedph1FSdata
            })


        default:
        return state
    }
}

export default personalInfo